import { getLineHeightInPx } from './inject-mobile-line-height-class';
import { getStyleProp } from './css-property-utils';
export var recalculateLineHeight = function (element, fallbacks) {
    var lineHeightInPx = getLineHeightInPx(element, fallbacks);
    return element.css('line-height', parseInt(lineHeightInPx || '', 10) + "px");
};
export var lineHeightExplicitInheritance = function (element, fallbacks) {
    var lineHeight = getStyleProp(element, 'line-height', fallbacks.css);
    return element.css('line-height', lineHeight);
};
//# sourceMappingURL=recalculate-line-height.js.map